import React from "react";
import Images from "../../Component/Simage";

function Pricing() {
  return (
    <div className="container ai-container">
      <div className="pricing">
        <p className="title fw-700 mb-0 text-center">Pricing</p>

        <div className="cus_grid">
          <div className="item lft_sec">
            <div>
              <p className="mb-0 label fw-400">Storage</p>
              <p className="mb-0 value fw-700">$20 per TB</p>
              <p className="mb-0 label fw-400">Monthly</p>
            </div>
          </div>
          <div className="item cntr_sec">
            <img src={Images.pricing} className="img-fluid gif_src" />
            <p className="mb-0 label fw-400 text-center">
              Includes 40,000 pinned files
            </p>
          </div>
          <div className="item ryt_sec">
            <div className="">
              <p className="mb-0 label fw-400">Bandwidth</p>
              <p className="mb-0 value fw-700">$20 per TB</p>
              <p className="mb-0 label fw-400">Usage</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Pricing;
